export enum LanguageType {
  GREMLIN = 'gremlin'
}

export type Language = LanguageType;